import {
  BO_VPU_DATA,
  BO_VPU_FILTERS_BY_VENDOR,
  BO_VPU_REPORT,
  BO_VPU_TABLE,
  BO_VPU_VENDOR_DETAILS,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

// dept, vendor , division
export const getVPUData = (
  aggr,
  location,
  division,
  department,
  vendor,
  page,
  limit,
  sort,
  sort_by,
  backorder
) => {
  const requestURL = BO_VPU_DATA;
  let obj = {
    sort_by: sort_by,
    sort: sort,
    group_by: aggr,
    backorder: backorder,
  };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }
  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getVPUTableData = (
  location,
  division,
  department,
  vendor,
  part,
  page,
  limit,
  backorder,
  caseId
) => {
  const requestURL = BO_VPU_TABLE;
  let obj = { backorder: backorder, case: caseId };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }
  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (part && part.length) {
    obj["part_list"] = part.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getVPUReport = (
  location,
  division,
  department,
  vendor,
  part,
  backorder,
  caseId
) => {
  const requestURL = BO_VPU_REPORT;
  let obj = { backorder: backorder, case: caseId };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }
  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (part && part.length) {
    obj["part_list"] = part.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getVPUVendorDetails = (
  division = null,
  department = null,
  page,
  limit,
  search
) => {
  let requestURL = BO_VPU_VENDOR_DETAILS;
  let obj = {};
  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  if (limit) {
    obj["limit"] = limit;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getVPUDivisionDeptByVendor = (vendor = null) => {
  const requestURL = BO_VPU_FILTERS_BY_VENDOR;
  let obj = {};

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
